// SPDX-License-Identifier: AGPL-3.0-or-later

import Navigation from '@app/features/navigation/state/Navigation';
import {Logger} from '@app/features/platform/utils/AppLogger';
import {FAVORITES_GUILD_ID, ME} from '@app/vendor/constants/AppConstants';

const logger = new Logger('Navigation');
type NavigationMode = 'push' | 'replace';
export function selectChannel(
	guildId?: string,
	channelId?: string | null,
	messageId?: string,
	mode: NavigationMode = 'push',
): void {
	logger.debug(`Selecting channel: guildId=${guildId}, channelId=${channelId}, messageId=${messageId}`);
	if (!guildId || guildId === ME) {
		Navigation.navigateToDM(channelId ?? undefined, messageId, mode);
	} else if (guildId === FAVORITES_GUILD_ID || guildId === '@favorites') {
		Navigation.navigateToFavorites(channelId ?? undefined, messageId, mode);
	} else {
		Navigation.navigateToGuild(guildId, channelId ?? undefined, messageId, mode);
	}
}
export function selectGuild(guildId: string, channelId?: string, mode: NavigationMode = 'push'): void {
	logger.debug(`Selecting guild: ${guildId}`);
	if (guildId === ME) {
		Navigation.navigateToDM(channelId, undefined, mode);
	} else if (guildId === FAVORITES_GUILD_ID || guildId === '@favorites') {
		Navigation.navigateToFavorites(channelId, undefined, mode);
	} else {
		Navigation.navigateToGuild(guildId, channelId, undefined, mode);
	}
}
export function deselectGuild(): void {
	logger.debug('Deselecting guild');
	Navigation.navigateToDM();
}
export function navigateToMessage(
	guildId: string | null | undefined,
	channelId: string,
	messageId: string,
	mode: NavigationMode = 'push',
): void {
	logger.debug(`Navigating to message: channel=${channelId}, message=${messageId}`);
	if (!guildId || guildId === ME) {
		Navigation.navigateToDM(channelId, messageId, mode);
	} else if (guildId === FAVORITES_GUILD_ID || guildId === '@favorites') {
		Navigation.navigateToFavorites(channelId, messageId, mode);
	} else {
		Navigation.navigateToGuild(guildId, channelId, messageId, mode);
	}
}
export function clearMessageIdForChannel(channelId: string, mode: NavigationMode = 'replace'): void {
	logger.debug(`Clearing messageId for channel: ${channelId}`);
	Navigation.clearMessageIdForChannel(channelId, mode);
}
